/**
 * @generated SignedSource<<1645b9bfe81ab2f0a62d5ae17023bf46>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type presetConfigurationsQueriesDeleteMacroCategoryMutation$variables = {
  id: number;
};
export type presetConfigurationsQueriesDeleteMacroCategoryMutation$data = {
  readonly deleteMacroCompositionCategory: {
    readonly displayOrder: number;
    readonly id: string;
    readonly macroCategoryID: number;
    readonly name: string | null;
    readonly sellerID: number;
  };
};
export type presetConfigurationsQueriesDeleteMacroCategoryMutation = {
  response: presetConfigurationsQueriesDeleteMacroCategoryMutation$data;
  variables: presetConfigurationsQueriesDeleteMacroCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CompositionMacroCategory",
    "kind": "LinkedField",
    "name": "deleteMacroCompositionCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "macroCategoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayOrder",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesDeleteMacroCategoryMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presetConfigurationsQueriesDeleteMacroCategoryMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "4d298a911db19c2dc898da46ae0e79ce",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesDeleteMacroCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation presetConfigurationsQueriesDeleteMacroCategoryMutation(\n  $id: Long!\n) {\n  deleteMacroCompositionCategory(id: $id) {\n    id\n    macroCategoryID\n    name\n    sellerID\n    displayOrder\n  }\n}\n"
  }
};
})();

(node as any).hash = "45d0b8fa01442fe33c6515454235a552";

export default node;
